<template>
  <div class="data-monitor">
    <el-card>
      <div slot="header"
           class="clearfix">
        <span>{{ $t('dataInput.dataMonitoring') }}</span>
      </div>
      <el-form :model="data"
               status-icon
               label-width="85px"
               class="demo-ruleForm"
               ref="ruleForm"
               :rules="rules">
        <el-form-item :label="$t('dataInput.deviceName')"
                      prop="deviceName">
          <el-input type="text" size="mini"
                    v-model="data.deviceName"
                    :placeholder="$t('dataInput.enterDeviceName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dataInput.opcAddress')"
                      prop="opcAddress">
          <el-input v-model="data.opcAddress" size="mini"
                    :placeholder="$t('dataInput.enterOpcDes')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dataInput.equipDes')"
                      prop="TagDes">
          <el-input size="mini"
                    v-model="data.TagDes"
                    :placeholder="$t('dataInput.enterEquipDes')"></el-input>

        </el-form-item>
        <el-form-item :label="$t('addEditMonitor.unit')"
                      prop="Unit">
          <el-select v-model="data.Unit" size="mini">
            <el-option v-for="item in UnitOption"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('addEditMonitor.tag')"
                      prop="posNo">
          <el-input type="text" size="mini"
                    v-model="data.posNo"
                    :placeholder="$t('menu.qsrwh')"></el-input>

        </el-form-item>
        <el-form-item :label="$t('menu.region')"
                      prop="area">
          <el-select v-model="data.area" size='mini'>
            <el-option v-for="item in areaList"
                       :key="item.glid"
                       :label="item.name"
                       :value="item.glid">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btnmg">
        <el-button @click="cancle()" size="mini">取消</el-button>
        <el-button type="primary" @click="save()" size="mini">{{$t('menu.save')}}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'dataMonitor',
  props: ['modalInfo'],
  data() {
    return {
      UnitOption: [{
        value: 'kpa',
        label: 'kpa'
      },
      {
        value: 'r/m',
        label: 'r/m'
      },
      {
        value: 'sm³/d',
        label: 'sm³/d'
      }],
      isEdit: false,
      formdata: null,
      data: {
        deviceName: '',
        opcAddress: '',
        selectData: '',
        TagDes: '',
        Unit: '',
        posNo: '',
        area: ''
      },
      rules: {
        deviceName: [{
          required: true,
          message: this.$t('menu.qsrsbmc'),
          trigger: 'blur'
        },
        {
          min: 1,
          max: 15,
          message: this.$t('menu.length15'),
          trigger: 'blur'
        }
        ],
        opcAddress: [{
          required: true,
          message: this.$t('menu.sropc'),
          trigger: 'blur'
        },
        {
          min: 1,
          max: 100,
          message: this.$t('menu.length100'),
          trigger: 'blur'
        }
        ],
        Unit: [{
          required: true,
          message: this.$t('menu.qxz'),
          trigger: 'change'
        }],
        posNo: [
          {
            required: true,
            message: this.$t('menu.qsrwh'),
          }
        ],
        area: [
          {
            required: true,
            message: this.$t('menu.qxz'),
            trigger: 'change'
          }
        ],
        TagDes: [{
          required: true,
          message: this.$t('menu.srsropc'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('menu.length100'),
          trigger: 'blur'
        }]
      },
      selectOptions: [{
        value: 1,
        label: '1秒'
      },
      {
        value: 2,
        label: '2秒'
      }
      ],
      show: true,
      showResult: false,
      areaList: []
    }
  },
  created() {
    this.getAreaList()
  },
  mounted() {
    this.setData(this.modalInfo)
  },
  watch: {
    modalInfo: function(val) {
      this.setData(val)
    }
  },

  methods: {
    setData(val) {
      if (val) {
        this.data.deviceName = val.DeviceName
        this.data.opcAddress = val.OPCAddress
        this.data.selectData = ''
        this.data.TagDes = val.TagDes
        this.data.Unit = val.Unit
        this.data.posNo = val.posNo
        this.data.area = val.area
      }
    },
    close() {
      this.$emit('close')
    },
    cancle() {
      this.$store.commit('closeModal', 'dataMonitor')
    },
    getAreaList() {
      ApiService.amis.getAreaList({
        mileageID: window.R_config.modelId
      }).then(res => {
        // console.log(res)
        this.areaList = res.data
      })
    },
    save() {
      let isChecked = true
      this.$refs['ruleForm'].validate(valid => {
        isChecked = valid
      })
      if (!isChecked) {
        return
      }
      // this.ruleForm.opcAddress
      var msg = ''
      var func = null
      var _data = {}
      if (!this.modalInfo) {
        func = ApiService.tree.add
        _data = {
          id: 0,
          DeviceName: this.data.deviceName,
          OPCAddress: this.data.opcAddress,
          DeviceItem: this.data.DeviceItem,
          TagWidth: 12,
          TagHeight: 23,
          TagStyle: 5,
          DevicePosition: '',
          CameraPos: '',
          mileageID: window.R_config.modelId,
          ChildID: '',
          Type: 1,
          TagDes: this.data.TagDes,
          Unit: this.data.Unit,
          posNo: this.data.posNo,
          areaName: this.data.area
        }
        msg = '添加成功！'
      } else {
        _data = {
          id: this.modalInfo.ID,
          DeviceName: this.data.deviceName,
          OPCAddress: this.data.opcAddress,
          DeviceItem: this.data.DeviceItem,
          TagWidth: 12,
          TagHeight: 23,
          TagStyle: 5,
          DevicePosition: this.modalInfo.DevicePosition,
          CameraPos: this.modalInfo.CameraPos,
          mileageID: window.R_config.modelId,
          ChildID: this.modalInfo.ChildID,
          Type: 1,
          TagDes: this.data.TagDes,
          Unit: this.data.Unit,
          areaName: this.data.area
        }
        func = ApiService.tree.update
        msg = '修改成功！'
      }
      func(_data)
        .then(res => {
          if (res.code == 0) {
            this.$refs['ruleForm'].resetFields()
            this.$message({
              message: msg,
              type: 'success'
            })
            this.$store.commit('closeModal', 'dataMonitor')
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
          this.showResult = false
        })
    },
    getResult() {
      this.showResult = !this.showResult
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.data-monitor {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  .el-card {
    width: 560px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/dataMonitor.vue